export default function initTopMsg() {
  document.querySelectorAll('.js-top-panel').forEach((topPanel) => {
    const close = document.querySelector('.close');
    const closeClass = 'closed-top-bar';

    close &&
      close.addEventListener('click', (e) => {
        e.preventDefault();
        topPanel.classList.add(closeClass);

        setTimeout(() => {
          topPanel.remove();
        }, 1500);
      });
  });
}
